<template>
  <!-- ヒーローセクションをスロットとして提供 -->
  <slot name="hero"></slot>

  <template v-if="isAllowed">
    <div v-if="announcements.length > 0" class="announcement-wrapper">
      <AnnouncementBanner
        v-for="item in announcements"
        :id="item.id"
        :key="item.id"
        :title="item.title"
      />
    </div>
  </template>

  <!-- メインコンテンツ -->
  <slot></slot>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
// メンテナンス情報表示用のコンポーネント
import { getAnnouncements, mapAnnouncementListResponseData } from '@/apis/announcement.api';
import AnnouncementBanner from '@/components/shared/announcement-banner/index.vue';
import type { AnnouncementData } from '@/types/announcement';

const route = useRoute();

const announcements = ref<AnnouncementData[]>([]);
const isAllowed = ref<boolean>(false);

/** トップ（/）のお知らせは TopGuestView 内（クイック検索直上）で表示する */
const allowPath = (path: string): boolean => {
  return path === '/candidate/login';
};

const loadAnnouncements = async (): Promise<void> => {
  try {
    const res = await getAnnouncements();
    announcements.value = mapAnnouncementListResponseData(res.data);
  } catch (error) {
    console.error('お知らせ情報の取得に失敗しました', error);
  }
};

watch(
  () => route.path,
  async (newPath) => {
    const allowed = allowPath(newPath);
    isAllowed.value = allowed;
    if (allowed) {
      if (announcements.value.length === 0) {
        await loadAnnouncements();
      }
    } else {
      announcements.value = [];
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.announcement-wrapper {
  width: 100%;
}

.announcement-wrapper .announcement-container {
  margin-bottom: 16px;
}
</style>
